import moment from 'moment';

const isDateOlder = (date: moment.Moment, duration: moment.Duration): boolean =>
    date.clone().add(duration).isAfter(moment());

const isNonEmptyString = (value: any): boolean => typeof value === 'string' && value.length > 0;

const isNumeric = (value: string) => /^\d+$/.test(value);

const isEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export { isDateOlder, isNonEmptyString, isNumeric, isEmail };
